import * as React from 'react'

import { UI } from 'Icon/ui'
import Icon from '../Icon'

import './FromTo.scss'

interface FromToProps {
  fromSubject: string | JSX.Element
  fromIcon?: JSX.Element
  fromAnswer: string | JSX.Element
  toSubject: string | JSX.Element
  toIcon?: JSX.Element
  toAnswer: string | JSX.Element
  toIconProps?: object
  fromIconProps?: object
  children?: React.ReactNode | undefined
}

const FromTo: React.FC<FromToProps> = props => {
  return (
    <div className={`srprs-from-to`}>
      <div>
        <span>{props.fromSubject}:</span>
        {!props.fromIcon ? (
          ''
        ) : (
          <Icon icon={props.fromIcon} iconProps={props.fromIconProps} />
        )}
        <strong>{props.fromAnswer}</strong>
      </div>
      <div>
        <Icon icon={UI.chevronRight} />
      </div>
      <div>
        <span>{props.toSubject}:</span>
        {!props.toIcon ? (
          ''
        ) : (
          <Icon icon={props.toIcon} iconProps={props.toIconProps} />
        )}
        <strong>{props.toAnswer}</strong>
      </div>
      {props.children}
    </div>
  )
}

export default FromTo
